import { createApi } from "@reduxjs/toolkit/query/react";
import axiosNewBaseQuery from "../../util/axiosNewBaseQuery";
import { SubscriptionSummary } from "types/bookingCreation";

interface CancelSubscriptionPayload {
  id: string;
  cancelAtPeriodEnd?: boolean;
  /** The consumer's withdrawal (§ 356a BGB): ends the subscription at once. */
  withdraw?: boolean;
}

export const customerAgreementsApiSlice = createApi({
  reducerPath: "customerAgreementsApiSlice",
  baseQuery: axiosNewBaseQuery(),
  tagTypes: ["CustomerAgreements"],
  endpoints: (builder) => ({
    getCustomerAgreementsByIds: builder.query<SubscriptionSummary[], string>({
      query: (subscriptionIds) => ({
        url: `/customer-agreements/${subscriptionIds}`,
      }),
      providesTags: ["CustomerAgreements"],
    }),
    cancelSubscription: builder.mutation<void, CancelSubscriptionPayload>({
      query: ({ id, cancelAtPeriodEnd, withdraw }) => ({
        url: `/customer-agreements/${id}/cancel`,
        method: "PUT",
        data: withdraw ? { withdraw: true } : { cancelAtPeriodEnd },
      }),
      invalidatesTags: ["CustomerAgreements"],
    }),
  }),
});

export const { 
  useGetCustomerAgreementsByIdsQuery, 
  useLazyGetCustomerAgreementsByIdsQuery,
  useCancelSubscriptionMutation 
} = customerAgreementsApiSlice;